export function requestPermissions(callback) {}
export function requestExactAlarmPermissions() {}
export default function checkPermissions(callback) {}
